var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from "react";
import { Select } from "../select/Select";
import { countries } from "@lysaab/shared";
export const CountrySelect = (_a) => {
    var { value, placeholder, omitList = [], language, name = "country", autoComplete = "country" } = _a, props = __rest(_a, ["value", "placeholder", "omitList", "language", "name", "autoComplete"]);
    const [countryAlternatives, setCountryAlternatives] = useState(countries[language].map((country) => {
        return {
            text: country.label,
            value: country.value,
        };
    }));
    useEffect(() => {
        setCountryAlternatives(countries[language].map((country) => ({
            text: country.label,
            value: country.value,
        })));
    }, [language]);
    return (React.createElement(Select, Object.assign({ alternatives: countryAlternatives.filter((country) => !omitList.includes(country.value)), placeholder: placeholder || "", value: countryAlternatives.find((country) => country.value === value), name: name, autoComplete: autoComplete }, props)));
};
